// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.select-label .el-form-item__label .el-input__inner {\n  border: 0;\n  font-weight: bold;\n  padding: 0;\n  height: 25px !important;\n  line-height: 25px !important;\n}\n", ""]);
// Exports
module.exports = exports;
